import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { getUserPickupOrders } from '../userPkgService'

export const useUserPickupOrders = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER_PICKUP_ORDERS],
    queryFn: () => getUserPickupOrders(),
  })
}
